<template>
  <div v-if="person.personId && person.intro">
    <Title title="名人传略" />
    <div v-if="person.intro" class="content-wrap" style="text-align: left">
      <div class="content">{{ person.intro }}</div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/Title'
import { getPerson } from '@/api/PersonApi'
export default {
  name: 'PersonIntro',
  components: {
    Title
  },
  props: {
    personId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      person: {
        personId: '',
        name: '',
        intro: ''
      }
    }
  },
  created() {
    getPerson(this.personId)
      .then(resp => {
        this.person = resp.data
      })
  }

}
</script>

<style lang="scss" scoped>
.content-wrap {
  padding: 20px;
  .content {
    line-height: 30px;
    text-indent: 2em;
  }
}

</style>
